import styled from 'styled-components';

const FooterButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
`;

export default FooterButtonContainer;
